import {
  GET_LIST,
  GET_ONE,
  GET_MANY,
  GET_MANY_REFERENCE,
  CREATE,
  UPDATE,
  DELETE,
  fetchUtils
} from 'react-admin';

export const GET_REPORT = 'GET_REPORT';

export default (apiUrl, httpClient = fetchUtils.fetchJson) => {
  const convertRESTRequestToHTTP = (type, resource, params) => {
    let url = '';
    const options = {};
    // console.log("convertRESTRequestToHTTP params: ", params);
    // console.log("convertRESTRequestToHTTP type: ", type);
    switch (type) {
      case GET_LIST: {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        let sort = field;
        // sort = '-updated_at'
        // if (field === 'id') {
        //   sort = "updated_at";
        // }

        if (order === 'DESC') {
          sort = "-" + sort;
        }
        const query = {
          ...params.filter,
          sort: sort,
          page: page,
          limit: perPage
        };
        url = `${apiUrl}/${resource}?${fetchUtils.queryParameters(query)}`;
        break;

      }
      case GET_ONE: {
        url = `${apiUrl}/${resource}/${params.id}`;
        break;
      }

      case GET_REPORT: {
        url = `${apiUrl}/${resource}`;
        break;
      }

      case GET_MANY_REFERENCE: {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        let sort = field;
        if (order === 'DESC') {
          sort = "-" + field;
        }
        const query = {
          ...params.filter,
          [params.target]: params.id,
          sort: sort,
          page: page,
          limit: perPage
        };
        url = `${apiUrl}/${resource}?${fetchUtils.queryParameters(query)}`;
        break;

      }
      // case GET_MANY: {
      //   const query = {'ids': params.ids};
      //   url = `${apiUrl}/${resource}?${fetchUtils.queryParameters(query)}`;
      //   break;
      // }
      case UPDATE: {
        url = `${apiUrl}/${resource}/${params.id}`;
        options.method = 'PATCH';
        options.body = JSON.stringify(params.data);
        break;

      }
      case CREATE: {
        url = `${apiUrl}/${resource}`;
        options.method = 'POST';
        options.body = JSON.stringify(params.data);
        break;

      }
      case DELETE: {
        url = `${apiUrl}/${resource}/${params.id}`;
        options.method = 'DELETE';
        break;
      }
      default:
        throw new Error(`Unsupported fetch action type ${type}`);
    }
    // console.log("convertRESTRequestToHTTP url: ", url);
    return { url, options };
  };

  const convertHTTPResponseToREST = (response, type, resource, params) => {
    const { headers, json } = response;
    // console.log("convertHTTPResponseToREST json: ", json);
    // console.log("convertHTTPResponseToREST type: ", type);
    switch (type) {
      case GET_LIST:
      case GET_MANY_REFERENCE:
        return {
          data: json.data.map(x => ({ ...x, id: x._id })),
          total: parseInt(json.total, 10)
        };
      case CREATE:
      case GET_ONE:
      case UPDATE:
        return { data: { ...json.data, id: json.data._id } };
      case DELETE:
        return { data: { ...json.data, id: json.data._id } };
      case GET_MANY:
        return {
          data: json.data.map(x => ({ ...x, id: x._id }))
        }
      default:
        return { data: { ...json.data, id: json.data._id } };
    }
  };

  return (type, resource, params) => {
    // console.log('========Req Body==========: ', params)

    // json-server doesn't handle WHERE IN requests, so we fallback to calling GET_ONE n times instead
    if (type === GET_MANY) {
      return Promise.all(params.ids.map(id => httpClient(`${apiUrl}/${resource}/${id}`)))
        .then(responses => ({ data: responses.map(r => ({ ...r.json.data, id: r.json.data._id })) }));
    }
    if ((type === UPDATE || type === CREATE) && resource === 'admin/messages') {
      if (params.data.address) {
        params.data = {
          ...params.data,
          address: params.data.address.address,
          location: params.data.address.location
        }
      }
    }
    const { url, options } = convertRESTRequestToHTTP(type, resource, params);
    return httpClient(url, options)
      .then(response => convertHTTPResponseToREST(response, type, resource, params));
  }
}
